<template>
  <div class="page-not-found">
    <div class="page-not-found__cloud-list">
      <div class="page-not-found__cloud x1"></div>
      <div class="page-not-found__cloud x2"></div>
      <div class="page-not-found__cloud x3"></div>
      <div class="page-not-found__cloud x4"></div>
      <div class="page-not-found__cloud x5"></div>
    </div>
    <div class='page-not-found__content'>
      <div class='page-not-found__404'>404</div>
      <hr>
      <div class='page-not-found__tip'>oOh，这个页面不见了</div>
      <a class='page-not-found__btn-back' href='javascript:;' @click="handleBtnBackClick">返回 (Back)</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'page-not-found',
  methods: {
    handleBtnBackClick () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
.page-not-found {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 100vw;
  height: 100vh;
  background-color: $primary-color;
  color: #fff;
  font-family: sans-serif;

  &__content {
    position: relative;
    z-index: 2;
    text-align: center;
  }

  &__404 {
    display: inline-block;
    font-size: 120px;
    letter-spacing: 15px;
    line-height: 1;
  }

  hr {
    width: 320px;
    padding: 0;
    margin: 0;
    border-top: 3px solid #fff;
  }

  &__tip {
    margin: 10px 0;
    font-size: 24px;
  }

  &__btn-back {
    display: inline-block;
    width: 320px;
    height: 38px;
    line-height: 38px;
    background-color: #fff;
    color: $primary-color;
    font-size: 20px;
    text-decoration: none;

    &:hover {
      color: $primary-color;
      animation: scaleFont 1s;
    }
  }

  &__cloud {
    width: 350px;
    height: 120px;
    margin: 120px 0 20px;
    border-radius: 100px;
    background-color: #fff;
    position: absolute;

    &:after,
    &:before {
      content: '';
      position: absolute;
      background: #fff;
    }

    &:after {
      width: 100px;
      height: 100px;
      top: -50px;
      left: 50px;
      border-radius: 100px;
    }

    &:before {
      width: 180px;
      height: 180px;
      top: -90px;
      right: 50px;
      border-radius: 200px;
    }

    &.x1 {
      left: -10vw;
      top: -10px;
      transform: scale(0.3);
      opacity: 0.3;
      animation: moveclouds 15s linear infinite;
    }

    &.x2 {
      left: 20vw;
      top: 50px;
      transform: scale(0.45);
      opacity: 0.5;
      animation: moveclouds 25s linear infinite;
    }

    &.x3 {
      left: 50vw;
      bottom: 80px;
      transform: scale(0.6);
      opacity: 0.7;
      animation: moveclouds 25s linear infinite;
    }

    &.x4 {
      left: 80vw;
      bottom: 10px;
      transform: scale(0.75);
      opacity: 0.9;
      animation: moveclouds 18s linear infinite;
    }

    &.x5 {
      left: 30vw;
      top: 180px;
      transform: scale(0.5);
      opacity: 0.8;
      animation: moveclouds 20s linear infinite;
    }
  }
}

@keyframes moveclouds {
  0% {
    margin-left: 120vw;
  }
  100% {
    margin-left: -120vw;
  }
}

@keyframes scaleFont {
  0% {
    font-size: 20px;
  }
  50% {
    font-size: 21px;
  }
  100% {
    font-size: 20px;
  }
}
</style>
